import Ajax from '../libraries/Ajax'

export const byLocation = (lat, lng) =>
    Ajax.get('events/list_experiences/0/12', {lat, lng})
    
export const filter = (filter, limit = 20) =>
    Ajax.get(`events/list_experiences/0/${limit}?filter=${filter}`)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/utils/experiences.js